import gql from 'graphql-tag';

export default gql`
query search(
  $account_info_business_name : String
){
  accountInfoList(
	  	account_info_business_name :$account_info_business_name
  	) {
    account_info {
      _id
      account_info_business_name
    }
    total_page
  }
}
`;


